module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAD1BMVEXdAAD/zgAAAADKysoCAAC/euC/AAAA0ElEQVR42u3OQQ3CQBRAwU1QQHBADQDFAfjXxKEK3omfdEbBrH2k9boPtGlpHbQKrUKr0Cq0Cq1Cq9AqtAqtQqvQKrQKrUKr0Cq0Cq1Cq9AqtAqtQqvQKrT+alvv70Cf9VgDXbS0DlqFVqFVaBVahVahVWgVWoVWoVVoFVqFVqFVaBVahVahVWgVWoVWoVVoFVqFVqFVnKf1vA5009I6aBVahVahVWgVWoVWoVVoFVqFVqFVaBVahVahVWgVWoVWoVVoFVqFVqFVaBXnae0j/QDQnPB1tFw0mgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/17.png
// module id = r7ri
// module chunks = 1